export {
  isSomeElementSelected,
  getElementsWithinSelection,
  getSelectedElements,
  getTargetElements,
} from "@excalidraw/element";
export { getScrollToContentState } from "../viewport";
export {
  hasBackground,
  hasStrokeWidth,
  hasStrokeStyle,
  hasFreedrawMode,
  canHaveArrowheads,
  canChangeRoundness,
} from "@excalidraw/element";
export {
  getNormalizedZoom,
  getNormalizedGridSize,
  getNormalizedGridStep,
} from "./normalize";
